export const quirkiesNFTs = [
  
  {
    "id": "quirkies-4999",
    "name": "Quirkies Originals #4999",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4999.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4998",
    "name": "Quirkies Originals #4998",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4998.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4997",
    "name": "Quirkies Originals #4997",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4997.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4996",
    "name": "Quirkies Originals #4996",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4996.png",
    "price": "1.65 ETH"
  },
  {
    "id": "quirkies-4995",
    "name": "Quirkies Originals #4995",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4995.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4994",
    "name": "Quirkies Originals #4994",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4994.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4993",
    "name": "Quirkies Originals #4993",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4993.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4992",
    "name": "Quirkies Originals #4992",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4992.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4991",
    "name": "Quirkies Originals #4991",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4991.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4989",
    "name": "Quirkies Originals #4989",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4989.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4986",
    "name": "Quirkies Originals #4986",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4986.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4988",
    "name": "Quirkies Originals #4988",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4988.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4985",
    "name": "Quirkies Originals #4985",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4985.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4990",
    "name": "Quirkies Originals #4990",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4990.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4984",
    "name": "Quirkies Originals #4984",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4984.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4983",
    "name": "Quirkies Originals #4983",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4983.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4987",
    "name": "Quirkies Originals #4987",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4987.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4982",
    "name": "Quirkies Originals #4982",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4982.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4981",
    "name": "Quirkies Originals #4981",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4981.png",
    "price": "0.75 ETH"
  },
  {
    "id": "quirkies-4980",
    "name": "Quirkies Originals #4980",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4980.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4979",
    "name": "Quirkies Originals #4979",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4979.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4978",
    "name": "Quirkies Originals #4978",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4978.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4977",
    "name": "Quirkies Originals #4977",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4977.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4976",
    "name": "Quirkies Originals #4976",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4976.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4974",
    "name": "Quirkies Originals #4974",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4974.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4975",
    "name": "Quirkies Originals #4975",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4975.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4973",
    "name": "Quirkies Originals #4973",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4973.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4972",
    "name": "Quirkies Originals #4972",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4972.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4971",
    "name": "Quirkies Originals #4971",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4971.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4970",
    "name": "Quirkies Originals #4970",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4970.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4969",
    "name": "Quirkies Originals #4969",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4969.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4966",
    "name": "Quirkies Originals #4966",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4966.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4968",
    "name": "Quirkies Originals #4968",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4968.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4965",
    "name": "Quirkies Originals #4965",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4965.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4967",
    "name": "Quirkies Originals #4967",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4967.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4963",
    "name": "Quirkies Originals #4963",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4963.png",
    "price": "0.75 ETH"
  },
  {
    "id": "quirkies-4964",
    "name": "Quirkies Originals #4964",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4964.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4962",
    "name": "Quirkies Originals #4962",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4962.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4960",
    "name": "Quirkies Originals #4960",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4960.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4961",
    "name": "Quirkies Originals #4961",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4961.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4959",
    "name": "Quirkies Originals #4959",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4959.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4956",
    "name": "Quirkies Originals #4956",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4956.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4958",
    "name": "Quirkies Originals #4958",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4958.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4957",
    "name": "Quirkies Originals #4957",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4957.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4954",
    "name": "Quirkies Originals #4954",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4954.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4953",
    "name": "Quirkies Originals #4953",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4953.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4952",
    "name": "Quirkies Originals #4952",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4952.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4955",
    "name": "Quirkies Originals #4955",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4955.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4951",
    "name": "Quirkies Originals #4951",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4951.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4950",
    "name": "Quirkies Originals #4950",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4950.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4948",
    "name": "Quirkies Originals #4948",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4948.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4949",
    "name": "Quirkies Originals #4949",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4949.png",
    "price": "1.15 ETH"
  },
    
  {
    "id": "quirkies-4947",
    "name": "Quirkies Originals #4947",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4947.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4944",
    "name": "Quirkies Originals #4944",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4944.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4946",
    "name": "Quirkies Originals #4946",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4946.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4945",
    "name": "Quirkies Originals #4945",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4945.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4943",
    "name": "Quirkies Originals #4943",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4943.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4942",
    "name": "Quirkies Originals #4942",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4942.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4941",
    "name": "Quirkies Originals #4941",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4941.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4940",
    "name": "Quirkies Originals #4940",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4940.png",
    "price": "0.75 ETH"
  },
  {
    "id": "quirkies-4939",
    "name": "Quirkies Originals #4939",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4939.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4938",
    "name": "Quirkies Originals #4938",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4938.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4937",
    "name": "Quirkies Originals #4937",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4937.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4936",
    "name": "Quirkies Originals #4936",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4936.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4935",
    "name": "Quirkies Originals #4935",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4935.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4934",
    "name": "Quirkies Originals #4934",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4934.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4933",
    "name": "Quirkies Originals #4933",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4933.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4932",
    "name": "Quirkies Originals #4932",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4932.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4931",
    "name": "Quirkies Originals #4931",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4931.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4930",
    "name": "Quirkies Originals #4930",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4930.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4929",
    "name": "Quirkies Originals #4929",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4929.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4928",
    "name": "Quirkies Originals #4928",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4928.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4926",
    "name": "Quirkies Originals #4926",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4926.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4923",
    "name": "Quirkies Originals #4923",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4923.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4925",
    "name": "Quirkies Originals #4925",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4925.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4924",
    "name": "Quirkies Originals #4924",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4924.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4922",
    "name": "Quirkies Originals #4922",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4922.png",
    "price": "0.75 ETH"
  },
  {
    "id": "quirkies-4920",
    "name": "Quirkies Originals #4920",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4920.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4921",
    "name": "Quirkies Originals #4921",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4921.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4919",
    "name": "Quirkies Originals #4919",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4919.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4918",
    "name": "Quirkies Originals #4918",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4918.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4916",
    "name": "Quirkies Originals #4916",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4916.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4917",
    "name": "Quirkies Originals #4917",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4917.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4915",
    "name": "Quirkies Originals #4915",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4915.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4914",
    "name": "Quirkies Originals #4914",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4914.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4913",
    "name": "Quirkies Originals #4913",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4913.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4912",
    "name": "Quirkies Originals #4912",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4912.png",
    "price": "0.95 ETH"
  },
  {
    "id": "quirkies-4911",
    "name": "Quirkies Originals #4911",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4911.png",
    "price": "1.85 ETH"
  },
  {
    "id": "quirkies-4910",
    "name": "Quirkies Originals #4910",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4910.png",
    "price": "1.35 ETH"
  },
  {
    "id": "quirkies-4909",
    "name": "Quirkies Originals #4909",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4909.png",
    "price": "0.85 ETH"
  },
  {
    "id": "quirkies-4908",
    "name": "Quirkies Originals #4908",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4908.png",
    "price": "2.05 ETH"
  },
  {
    "id": "quirkies-4907",
    "name": "Quirkies Originals #4907",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4907.png",
    "price": "1.55 ETH"
  },
  {
    "id": "quirkies-4906",
    "name": "Quirkies Originals #4906",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4906.png",
    "price": "1.15 ETH"
  },
  {
    "id": "quirkies-4905",
    "name": "Quirkies Originals #4905",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4905.png",
    "price": "0.75 ETH"
  },
  {
    "id": "quirkies-4904",
    "name": "Quirkies Originals #4904",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4904.png",
    "price": "1.95 ETH"
  },
  {
    "id": "quirkies-4902",
    "name": "Quirkies Originals #4902",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4902.png",
    "price": "1.45 ETH"
  },
  {
    "id": "quirkies-4903",
    "name": "Quirkies Originals #4903",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4903.png",
    "price": "1.05 ETH"
  },
  {
    "id": "quirkies-4901",
    "name": "Quirkies Originals #4901",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4901.png",
    "price": "1.75 ETH"
  },
  {
    "id": "quirkies-4900",
    "name": "Quirkies Originals #4900",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4900.png",
    "price": "1.25 ETH"
  },
  {
    "id": "quirkies-4898",
    "name": "Quirkies Originals #4898",
    "image": "https://ipfs.io/ipfs/bafybeifm3xckuzmsfpj5qxo6w67h2w2m5wl5bdc7fdmqnfh54bmvgpq3cq/4898.png",
    "price": "0.85 ETH"
  }




];